var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.batches),function(batch){return _c('li',{key:batch.id},[_c('router-link',{attrs:{"to":("/dataset/" + _vm.datasetId + "/upload/" + (batch.id))}},[_vm._v(" Batch "+_vm._s(batch.id)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }